import React from 'react';
import work1 from "../../assets/images/home/work1.png";
import work2 from "../../assets/images/home/work2.png";
import work3 from "../../assets/images/home/work3.png";
import "../Home/index.css";

export const WhatMakes = () => {
   return (
     <div className='howItWorkContainer'>
         <div className='container'>
             <div className='howTitle'>What Makes Us Different</div>
             <div className='howSubTitle'>What Sets SnapBid Apart?</div>
             <div className='howGrid'>
                 <div className='howCard'>
                     <div><img src={work1}/></div>
                     <div>Structured Application Process</div>
                     <div>No random interest forms — every bid starts with a verified application and confirmed payment.</div>
 
                 </div>
                  <div className='howCard'>
                     <div><img src={work2}/></div>
                     <div>Visit Before You Bid</div>
                     <div>Users must physically visit the property before they can enter a bid, ensuring transparency and trust.</div>
 
                 </div>
                  <div className='howCard'>
                     <div><img src={work3}/></div>
                     <div>Smart Shortlisting & Bidding</div>
                     <div>Initial bids are reviewed based on amount, timing, and profile, and top bidders are invited for offline bidding.</div>
 
                 </div>
 
             </div>
 
         </div>
 
     </div>
   )
}
